export enum TimeType {
    Hour = 1,
    Minute = 2,
    Day = 3,
}